/**
 * Live Update manager.
 */
export class AirshipLiveUpdateManager {
    constructor(plugin) {
        this.plugin = plugin;
    }
    /**
     * Lists any Live Updates for the request.
     * @param request The request options.
     * @returns A promise with the result.
     */
    list(request) {
        return this.plugin.perform('liveUpdateManager#list', request);
    }
    /**
     * Lists all Live Updates.
     * @returns A promise with the result.
     */
    listAll() {
        return this.plugin.perform('liveUpdateManager#listAll');
    }
    /**
     * Starts a Live Update.
     * @param request The request options.
     * @returns A promise with the result.
     */
    start(request) {
        return this.plugin.perform('liveUpdateManager#start', request);
    }
    /**
     * Updates a Live Update.
     * @param request The request options.
     * @returns A promise with the result.
     */
    update(request) {
        return this.plugin.perform('liveUpdateManager#update', request);
    }
    /**
     * Ends a Live Update.
     * @param request The request options.
     * @returns A promise with the result.
     */
    end(request) {
        return this.plugin.perform('liveUpdateManager#end', request);
    }
    /**
     * Clears all Live Updates.
     * @returns A promise with the result.
     */
    clearAll() {
        return this.plugin.perform('liveUpdateManager#clearAll');
    }
}
//# sourceMappingURL=AirshipLiveUpdateManager.js.map